import React from 'react';
import classNames from 'classnames';

class ResetButton extends React.Component {
  constructor(props) {
    super(props);
  }
  handleReset() {
    this.props.handlebutton();
  }
  render() {
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    const defaultButtonTitle = this.props.buttontitle !== '' ? this.props.buttontitle : 'Reset URl';
    const defaultButtonStyle = this.props.buttonstyle !== '' ? this.props.buttonstyle : null;
    return (<div>
        <div className={childInputClass}>
          <button type="button" className={defaultButtonStyle + ' ' + 'reset-button' + ' ' + 'fluid'} onClick={this.handleReset.bind(this)}>{defaultButtonTitle}</button>
        </div>
      </div>
    );
  }
}

ResetButton.propTypes = {
  'buttontitle': React.PropTypes.string,
  'buttonstyle': React.PropTypes.string,
  'type': React.PropTypes.string,
  'buttonClass': React.PropTypes.string,
  'handlebutton': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,

};

export default ResetButton;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/resetbutton.js
 **/